module.exports = __webpack_public_path__ + "static/media/premium-icon.57e9cb14.png";